interface RecommendationCardProps {
  title: string;
  category: 'growth' | 'product' | 'infra';
  impact: string;
  risk: 'low' | 'medium' | 'high';
  rollout: string;
  description: string;
}

const catLabels: Record<string, { label: string; color: string }> = {
 growth: { label: 'Crescimento', color: 'text-green-400' },
 product: { label: 'Produto', color: 'text-blue-400' },
 infra: { label: 'Infra', color: 'text-orange-400' },
};

const riskColors: Record<string, string> = {
  low: 'bg-green-500/20 text-green-400',
  medium: 'bg-yellow-500/20 text-yellow-400',
  high: 'bg-red-500/20 text-red-400',
};

export function RecommendationCard({ title, category, impact, risk, rollout, description }: RecommendationCardProps) {
  const cat = catLabels[category] ?? catLabels.product;
  return (
    <div class="bg-gray-800 rounded-xl border border-gray-700 p-5 hover:bg-gray-750 transition-colors">
      <div class="flex items-start justify-between mb-2">
        <span class={`text-xs font-medium ${cat!.color}`}>{cat!.label}</span>
        <span class={`text-xs px-2 py-0.5 rounded-full font-medium ${riskColors[risk]}`}>
          Risco {risk === 'low' ? 'baixo' : risk === 'medium' ? 'médio' : 'alto'}
        </span>
      </div>
      <h3 class="text-white font-semibold mb-2">{title}</h3>
      <p class="text-sm text-gray-300 mb-3">{description}</p>
      <div class="flex items-center gap-4 text-xs text-gray-400">
 <span>Impacto: <strong class="text-gray-200">{impact}</strong></span>
 <span>Rollout: <strong class="text-gray-200">{rollout}</strong></span>
      </div>
    </div>
  );
}
